module.exports = __webpack_public_path__ + "img/Discord.52fd772d.svg";